import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=5d7552ed&scoped=true"
import script from "./RatingDisplay.vue?vue&type=script&lang=js"
export * from "./RatingDisplay.vue?vue&type=script&lang=js"
import style0 from "./RatingDisplay.vue?vue&type=style&index=0&id=5d7552ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7552ed",
  null
  
)

export default component.exports